<template>
    <div class="md-house-listing broker" v-if="exist">
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <div class="title">
                <div class="main-title">
                    <div class="mg-title" v-if="titleContent" :class="centerClass" v-html="formatFontSize(titleContent, '--mg-title-size')" style="font-family:var(--mg-title-font);"></div>
                </div>
                <h3
                    class="sub-title"
                    v-if="baseUrl"
                    v-html="
                        $t('md-house-listing.basedOnListing', {
                            href: baseUrl,
                            address: baseListingAddr
                        })
                    "
                ></h3>
                <h3
                    class="sub-title"
                    v-if="!forMoreData && dataType === 'recommend'"
                >
                    {{ subTitle }}
                </h3>
            </div>
            <HouseGrid />
        </module-box>
    </div>
</template>

<script>

import Common from '../index.js';
import { getAsyComponent } from '@/common/utils/load-module.js';
export default {
    components: {
        HouseGrid: getAsyComponent(() =>
            import(
                /* webpackChunkName: "modules/md-house/broker-grid_grid"*/ '../../md-house/broker-grid/grid.vue'
            ))
    },
    mixins: [Common]
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';
.md-house-listing.broker {
    > div {
        overflow: visible;
    }
    .title {
        position: relative;
        padding-bottom: 20px;
        .main-title {
            display: flex;
            align-items: center;
        }
        .mg-title {
            padding: 0;
            text-align: var(--mg-title-align);
        }
        .sub-title {
            margin: 0;
            font-size: 14px;
            line-height: 1;
            display: inline-block;
            max-width: calc(100% - 130px);
            font-family: var(--font-normal);
            white-space: inherit;
            color: #505050;
            font-weight: normal;
            a {
                color: var(--color-theme);
            }
        }
        .center {
            text-align: center;
        }
    
        @include media-600 {
            .mg-title {
                font-size: var(--mg-title-size-mobile);
            }
            .sub-title {
                font-size: 12px;
                max-width: calc(100% - 60px);
            }
        }
    }
 
}
</style>
